import moment from "moment-timezone";
import type { Meeting } from "@platform/types/platform.types";

/**
 * Returns true when the user has a meeting they could plausibly join:
 * - meeting is non-null
 * - and either has no end_time (ad-hoc / open meeting)
 * - or its end_time is in the future
 *
 * Used to decide whether to surface the "Join Meeting" CTA on the dashboard.
 */
export function hasJoinableMeeting(
  meeting: Meeting | null | undefined
): boolean {
  if (!meeting) return false;
  if (!meeting.end_time) return true;
  return moment(meeting.end_time).isAfter(moment.utc());
}

export default hasJoinableMeeting;
